import { string, bool, oneOfType, node, arrayOf, func } from 'prop-types';

import { PlusOutlined } from 'jl-design-system/components/icons/PlusOutlined';
import { MinusOutlined } from 'jl-design-system/components/icons/MinusOutlined';
import { UnderlinedButton } from 'jl-design-system/elements/button/Button';

import styles from './ToggleButton.scss';

export const ToggleButton = ({ className = '', opened, handleClick, children = [] }) => (
  <div className={className} data-testid="ToggleButton">
    <UnderlinedButton className={styles.Button} type="submit" onClick={handleClick}>
      <span>{children}</span>
      {opened ? <MinusOutlined size="medium" /> : <PlusOutlined size="medium" />}
    </UnderlinedButton>
  </div>
);

ToggleButton.propTypes = {
  className: string,
  opened: bool.isRequired,
  handleClick: func.isRequired,
  children: oneOfType([node, arrayOf(node)]),
};
